import { doGetOld } from '@/services/api/base'
import { ApiResponseOld } from '@/types/api'

/**
 * Ping the API
 * @returns Promise<ApiResponseOld> The response from the API
 */
export const ping = async (): Promise<ApiResponseOld> => {
  return await doGetOld('/api/ping')
}
